<aa-input-switch name="all"
                 label="{{ keyTrad | translate }}"
                 [checked]="state | async"
                 (toggleSwitch)="onToggleQuickSwitch($event)">
</aa-input-switch>
